<template>
  <div class="tw-bg-gray-50 tw-border-b tw-border-gray-200 tw-py-2">
    <div class="tw-container tw-mx-auto tw-px-6">
      <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-4 tw-text-sm">
        <!-- Left side: Phone and Email -->
        <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-4 md:tw-gap-6">
          <a
            v-if="appConfig.contact.phone"
            :href="`tel:${appConfig.contact.phone.replace(/[^\d+]/g, '')}`"
            class="tw-text-gray-600 hover:tw-text-primary-600 tw-transition-colors tw-flex tw-items-center tw-gap-1.5"
          >
            <svg class="tw-w-4 tw-h-4 tw-hidden sm:tw-inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <span>{{ appConfig.contact.phone }}</span>
          </a>
          <a
            v-if="appConfig.contact.email"
            :href="`mailto:${appConfig.contact.email}`"
            class="tw-text-gray-600 hover:tw-text-primary-600 tw-transition-colors tw-flex tw-items-center tw-gap-1.5"
          >
            <svg class="tw-w-4 tw-h-4 tw-hidden sm:tw-inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <span>{{ appConfig.contact.email }}</span>
          </a>
        </div>
        <!-- Right side: Address -->
        <div
          v-if="appConfig.contact.address"
          class="tw-text-gray-600 tw-flex tw-items-center tw-gap-1.5"
        >
          <svg class="tw-w-4 tw-h-4 tw-hidden sm:tw-inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span class="tw-text-xs md:tw-text-sm">{{ appConfig.contact.address }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import appConfig from '../config/app.config.js';
</script>

